
import { Component } from '@angular/core';

@Component({
    selector: 'shared-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent {
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/footer/footer.component.ts